import React from 'react';
import {
  AlertCircle,
  CheckCircle2,
  Circle,
  Clock3,
  PauseCircle,
  RefreshCw,
} from 'lucide-react';
import Badge from './Badge';
import {
  formatStatus,
  getStatusExplanation,
  getStatusVariant,
} from '../../utils/formatters';

const ICONS = {
  success: CheckCircle2,
  warning: Clock3,
  danger: AlertCircle,
  info: RefreshCw,
  neutral: Circle,
};

export default function StatusBadge({
  status,
  type = 'audit',
  label,
  explanation,
  variant,
  showExplanation = false,
  className = '',
}) {
  const resolvedVariant = variant || getStatusVariant(status);
  const resolvedLabel = label || formatStatus(status, type);
  const resolvedExplanation = explanation || getStatusExplanation(status, type);
  const Icon = status === 'suspended' ? PauseCircle : (ICONS[resolvedVariant] || Circle);

  return (
    <span className={`status-component ${className}`.trim()}>
      <Badge
        variant={resolvedVariant}
        title={resolvedExplanation || resolvedLabel}
        aria-label={resolvedExplanation ? `${resolvedLabel}. ${resolvedExplanation}` : resolvedLabel}
      >
        <Icon size={12} aria-hidden="true" />
        {resolvedLabel}
      </Badge>
      {showExplanation && resolvedExplanation ? (
        <span className="status-explanation">{resolvedExplanation}</span>
      ) : null}
    </span>
  );
}
